import { Component, OnInit } from '@angular/core';
import { NgWizardConfig, NgWizardService, THEME } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
  selector: 'app-brand-hub-steps',
  templateUrl: './brand-hub-steps.component.html',
  styleUrls: ['./brand-hub-steps.component.scss']
})
export class BrandHubStepsComponent implements OnInit {

  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows
  };
  createBrandFlag: boolean = true
  whitelistFlag: boolean = false
  brandHubdetails: any

  brandHubCreatedID: any
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private ngWixardService: NgWizardService
  ) {
    this.brandHubdetails = JSON.parse(localStorage.getItem("brandhubdeatails"))
  }

  ngOnInit() {
    if (this.brandHubdetails.ModalName == "edit") {
      this.gotoWhitelistUsers(true)
    }
  }

  gotoWhitelistUsers(event) {
    this.whitelistFlag = true
    setTimeout(() => {
      this.ngWixardService.next()
    }, 300)
    console.log(event)
  }

  getbrandHubCreatedID(event) {
    console.log(event)
    console.log('created Reward ID', event)
    this.brandHubCreatedID = event
  }

}
